// extracted by mini-css-extract-plugin
export default {"label":"form-select_label__jdjGM","select":"form-select_select__lU3cS","error":"form-select_error__hOBz9","error-message":"form-select_error-message__oMrzC"};